import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ajax from '../utils/ajax'
import functions from '../utils/functions'
import SimpleImageSlider from "react-simple-image-slider"

import ReactBeforeSliderComponent from 'react-before-after-slider-component';
import 'react-before-after-slider-component/dist/build.css';

import { Fab, Action } from 'react-tiny-fab';
import { FaHeadset } from "react-icons/fa";
import 'react-tiny-fab/dist/styles.css';


class Home extends Component {

    state = {
        username: '',
        password: '',
        type: '',
        info: '',
        load: false,
        showMsg: false,
        userId: functions.sessionGuard(),
        username: functions.loggedInUser(),
    }

    componentDidMount() {
    }


    render() {
        const roleList = functions.roleGuard()

        const images = [
            { url: "assets/images/main-slider/hero-1.jpg" },
            { url: "assets/images/main-slider/slide6.jpg" },
            { url: "assets/images/main-slider/slide7.jpg" },
            { url: "assets/images/main-slider/hero-3.jpg" },
            // { url: "assets/images/main-slider/slide12.jpg" },
            // { url: "assets/images/main-slider/pic1.jpg" },
            // { url: "assets/images/main-slider/pic3.jpg" },

        ];

        const FIRST_IMAGE = {
            imageUrl: 'assets/images/before/beforefill.png'
        };
        const SECOND_IMAGE = {
            imageUrl: 'assets/images/before/afterfill.png'
        };

        const FIRST_IMAGEW = {
            imageUrl: 'assets/images/before/vl-after-3.1.png'
        };
        const SECOND_IMAGEW = {
            imageUrl: 'assets/images/before/vl-after-3.2.png'
        };

        const FIRST_IMAGE2 = {
            imageUrl: 'assets/images/before/vl-before-3.2.png'
        };
        const SECOND_IMAGE2 = {
            imageUrl: 'assets/images/before/vl-after-3.2.png'
        };

        const FIRST_IMAGE3 = {
            imageUrl: 'assets/images/before/whitebf.png'
        };
        const SECOND_IMAGE3 = {
            imageUrl: 'assets/images/before/whiteaf.png'
        };

        const FIRST_IMAGE4 = {
            imageUrl: 'assets/images/before/implontbf.png'
        };
        const SECOND_IMAGE4 = {
            imageUrl: 'assets/images/before/implontaf.png'
        };

        const FIRST_IMAGEBB = {
            imageUrl: 'assets/images/before/bridgesb4.png'
        };
        const SECOND_IMAGEBA = {
            imageUrl: 'assets/images/before/bridgesAft.png'
        };

        const FIRST_IMAGECB = {
            imageUrl: 'assets/images/before/cleanb4.png'
        };
        const SECOND_IMAGECA = {
            imageUrl: 'assets/images/before/cleanaf.png'
        };

         const FIRST_IMAGEsb = {
            imageUrl: 'assets/images/before/scallingaf.png'
        };
        const SECOND_IMAGEsa = {
            imageUrl: 'assets/images/before/scallingb4.png'
            
        };

        return (
            <>


                <body id="bg">

                    {/* <div id="loading-area"></div> */}
                    <div class="page-scroll"></div>
                    <div class="page-wraper">
                        {/* <!-- header --> */}
                        <header class="site-header header header-style-4 style-1 mo-left">
                            <div class="bg-white">
                                <div class="container header-contant-block ">
                                    <div class="row d-flex justify-content-between align-items-center">
                                        <div class="col-lg-3">
                                            <div class="logo-header "><a href="/"><img src="assets/images/ntindadental.png" style={{
                                                width: "193",
                                                height: "69"
                                            }} /></a></div>
                                        </div>
                                        <div class="col-lg-9">
                                            <ul class="contact-info style-1 clearfix text-primary">
                                                <li>
                                                    <h6 class="text-primary"><i class="fa fa-phone"></i> Call Us</h6>
                                                    <span>+256 754 229 749</span>
                                                </li>
                                                <li>
                                                    <h6 class="text-primary"><i class="fa fa-envelope-o"></i> Send us a Mail</h6>
                                                    <span><a href="#"
                                                        class="__cf_email__">info@ntindadentalclinic.com</a></span>
                                                </li>
                                                <li>
                                                    <h6 class="text-primary"><i class="fa fa-clock-o"></i> Opening Time</h6>
                                                    <span>Mon -Sun: 7:00 - 20:00</span>
                                                </li>
                                                <li>
                                                    <h6 class="text-primary"><i class="fa fa-phone"></i>Call Toll Free</h6>
                                                    <span>+256 754 229 749</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- main header --> */}
                            <div class="sticky-header main-bar-wraper navbar-expand-lg">
                                <div class="main-bar clearfix ">
                                    <div class="navigation-bar bg-primary">
                                        <div class="container clearfix">
                                            {/* <!-- website logo --> */}
                                            <div class="logo-header mostion">
                                                <a href="/"><img src="assets/images/ntindadentalw.png" width="193" height="89"
                                                    alt="" /></a>
                                            </div>
                                            {/* <!-- nav toggle button --> */}
                                            <button class="navbar-toggler collapsed navicon justify-content-end" type="button"
                                                data-toggle="collapse" data-target="#navbarNavDropdown"
                                                aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </button>
                                            {/* <!-- extra nav --> */}
                                            {/* <div class="extra-nav">
                                                <div class="extra-cell">
                                                    <button id="quik-search-btn" type="button" class="site-button white"><i
                                                        class="fa fa-search"></i></button>
                                                </div>
                                            </div> */}
                                            {/* <!-- Quik search --> */}
                                            <div class="dez-quik-search bg-primary">
                                                <form action="#">
                                                    <input name="search" value="" type="text" class="form-control"
                                                        placeholder="Type to search" />
                                                    <span id="quik-search-remove"><i class="fa fa-remove"></i></span>
                                                </form>
                                            </div>
                                            {/* <!-- main nav --> */}
                                            <div class="header-nav navbar-collapse collapse justify-content-start"
                                                id="navbarNavDropdown">
                                                <ul class="nav navbar-nav">
                                                    <li class="active">
                                                        <a href="/">Home<i class="fa fa-chevron-down"></i></a>
                                                    </li>
                                                    <li> <a href="#about-us">About<i class="fa fa-chevron-down"></i></a>
                                                    </li>
                                                    <li> <a href="#our-services">Services<i class="fa fa-chevron-down"></i></a>
                                                    </li>
                                                    <li style={{ display: 'none' }}> <a href="#our-team">Team<i class="fa fa-chevron-down"></i></a>
                                                    </li>
                                                    <li> <a href="#contact-us">Contact<i class="fa fa-chevron-down"></i></a>
                                                    </li>
                                                    {/* <li> <a href="javascript:;">Blog<i class="fa fa-chevron-down"></i></a>
                                                        <ul class="sub-menu">
                                                            <li> <a href="javascript:;">list</a>
                                                                <ul class="sub-menu right">
                                                                    <li><a href="blog-list-no-sidebar.html">blog list no sidebar</a>
                                                                    </li>
                                                                    <li><a href="blog-list-right-sidebar.html">blog list right
                                                                        sidebar</a></li>
                                                                    <li><a href="blog-list-left-sidebar.html">blog list left sidebar</a>
                                                                    </li>
                                                                    <li><a href="blog-list-both-sidebar.html">Both Sidebar</a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Grid</a>
                                                                <ul class="sub-menu right">
                                                                    <li><a href="blog-grid-no-sidebar.html">blog grid no sidebar</a>
                                                                    </li>
                                                                    <li><a href="blog-grid-right-sidebar.html">blog grid right
                                                                        sidebar</a></li>
                                                                    <li><a href="blog-grid-left-sidebar.html">blog grid left sidebar</a>
                                                                    </li>
                                                                    <li><a href="blog-grid-both-sidebar.html">Both Sidebar</a></li>
                                                                    <li><a href="blog-grid-wide-sidebar.html">Wide Sidebar</a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Single</a>
                                                                <ul class="sub-menu right">
                                                                    <li><a href="blog-single.html">Single</a></li>
                                                                    <li><a href="blog-single-right-sidebar.html">Single Right
                                                                        sidebar</a></li>
                                                                    <li><a href="blog-single-left-sidebar.html">Single left sidebar</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Full Page Blog</a>
                                                                <ul class="sub-menu right">
                                                                    <li><a href="blog-full-grid-dark-style-1.html">Dark Style 1</a></li>
                                                                    <li><a href="blog-full-grid-dark-style-2.html">Dark Style 2</a></li>
                                                                    <li><a href="blog-full-grid-dark-style-3.html">Dark Style 3</a></li>
                                                                    <li><a href="blog-full-grid-light-style-1.html">Light Style 1</a>
                                                                    </li>
                                                                    <li><a href="blog-full-grid-light-style-2.html">Light Style 2</a>
                                                                    </li>
                                                                    <li><a href="blog-full-grid-light-style-3.html">Light Style 3</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li class="has-mega-menu "> <a href="javascript:;">Post Layout<i
                                                        class="fa fa-chevron-down"></i></a>
                                                        <ul class="mega-menu">
                                                            <li> <a href="javascript:;">Side Bar</a>
                                                                <ul>
                                                                    <li><a href="post-left-sidebar.html">Left Sidebar</a></li>
                                                                    <li><a href="post-right-sidebar.html">Right Sidebar</a></li>
                                                                    <li><a href="post-both-sidebar.html">Both Sidebar<span
                                                                        class="new-page">New</span></a></li>
                                                                    <li><a href="post-no-sidebar.html">No Sidebar</a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Post Types</a>
                                                                <ul>
                                                                    <li><a href="post-text.html">Text Post</a></li>
                                                                    <li><a href="post-image.html">Image Post</a></li>
                                                                    <li><a href="post-video.html">Video Post</a></li>
                                                                    <li><a href="post-link.html">Link Post</a></li>
                                                                    <li><a href="post-audio.html">Audio Post</a></li>
                                                                    <li><a href="post-quote.html">Post Quote</a></li>
                                                                    <li><a href="post-tutorial.html">Tutorial Post<span
                                                                        class="new-page">New</span></a></li>
                                                                    <li><a href="post-cateloge.html">Cateloge Post<span
                                                                        class="new-page">New</span></a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Multiple Media</a>
                                                                <ul>
                                                                    <li><a href="post-banner.html">Banner<span
                                                                        class="new-page">New</span></a></li>
                                                                    <li><a href="post-slide-show.html">Slider</a></li>
                                                                    <li><a href="post-gallery.html">Gallery</a></li>
                                                                    <li><a href="post-status.html">Status Slider<span
                                                                        class="new-page">New</span></a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Post Layout Type</a>
                                                                <ul>
                                                                    <li><a href="post-standard.html">Standard Post</a></li>
                                                                    <li><a href="post-side.html">Side Post<span
                                                                        class="new-page">New</span></a></li>
                                                                    <li><a href="post-corner.html">Corner Post<span
                                                                        class="new-page">New</span></a></li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li class="has-mega-menu "> <a href="javascript:;">Shortcodes<i
                                                        class="fa fa-chevron-down"></i></a>
                                                        <ul class="mega-menu">
                                                            <li> <a href="javascript:;">Shortcodes</a>
                                                                <ul>
                                                                    <li><a href="shortcode-buttons.html">Buttons</a></li>
                                                                    <li><a href="shortcode-icon-box-styles.html">Icon box styles</a>
                                                                    </li>
                                                                    <li><a href="shortcode-pricing-table.html">Pricing table</a></li>
                                                                    <li><a href="shortcode-toggles.html">Toggles</a></li>
                                                                    <li><a href="shortcode-team.html">Team</a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Shortcodes</a>
                                                                <ul>
                                                                    <li><a href="shortcode-carousel-sliders.html">Carousel sliders</a>
                                                                    </li>
                                                                    <li><a href="shortcode-image-box-content.html">Image box content</a>
                                                                    </li>
                                                                    <li><a href="shortcode-tabs.html">Tabs</a></li>
                                                                    <li><a href="shortcode-counters.html">Counters</a></li>
                                                                    <li><a href="shortcode-light-box.html">Light Gallery </a></li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Shortcodes</a>
                                                                <ul>
                                                                    <li><a href="shortcode-accordians.html">Accordians</a></li>
                                                                    <li><a href="shortcode-dividers.html">Dividers</a></li>
                                                                    <li><a href="shortcode-images-effects.html">Images effects</a></li>
                                                                    <li><a href="shortcode-testimonials.html">Testimonials</a></li>
                                                                    <li><a href="shortcode-magnific-popup.html">Magnific Gallery </a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                            <li> <a href="javascript:;">Shortcodes</a>
                                                                <ul>
                                                                    <li><a href="shortcode-alert-box.html">Alert box</a></li>
                                                                    <li><a href="shortcode-icon-box.html">Icon-box</a></li>
                                                                    <li><a href="shortcode-list-group.html">List group</a></li>
                                                                    <li><a href="shortcode-title-separators.html">title-separators</a>
                                                                    </li>
                                                                    <li><a href="shortcode-all-widgets.html">Widgets</a></li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li> */}

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- main header END --> */}
                        </header>
                        {/* <!-- header END --> */}
                        {/* <!-- Content --> */}
                        <div class="page-content">
                            {/* <!-- Slider --> */}
                            <div class="main-slider style-two default-banner">
                                <div class="tp-banner-container">
                                    <div class="tp-banner">


                                        <div>
                                            <SimpleImageSlider
                                                width={'100%'}
                                                height={604}
                                                images={images}
                                                showBullets={true}
                                                showNavs={true}
                                            />


                                        </div>



                                    </div>
                                </div>
                            </div>
                            {/* <!-- Slider END -->
			<!-- About Company --> */}
                            <div class="section-full content-inner bg-white video-section" id='about-us'>
                                <div class="container">
                                    <div class="section-content">
                                        <div class="row d-flex">
                                            <div class="col-lg-6 col-md-6 align-self-center m-b30">
                                                <h2 class="m-b15">Dental Care with <br /><span class="text-primary">Ntinda Dental Clinic</span>
                                                </h2>
                                                <p class="m-b15">At Ntinda Dental Clinic, we combine modern technology with compassionate expertise to deliver safe, effective, and comfortable treatments. From routine check-ups to advanced procedures, your oral health is our priority.

                                                    Our dedicated team is committed to helping you achieve a healthy, confident smile in a welcoming environment.
                                                </p>
                                                <p class="m-b30">We focus on personalized care, ensuring every patient receives the attention and quality treatment they deserve. Your smile starts here.</p>
                                                <img src="assets/images/sign.png" width="200" alt="" />
                                                <h4 class="m-b0">Niyang . A . W</h4>
                                                <span class="font-14">HOSPITAL DIRECTOR</span>
                                            </div>
                                            <div class="col-lg-6 col-md-6 m-b30">
                                                <div class="video-bx">
                                                    <img src="assets/images/pic1.jpg" alt="" />
                                                    <div class="video-play-icon">
                                                        {/* <a href="../../www.youtube.com/watch86ea.html?v=f4Bts39jimI"
                                                            class="popup-youtube video bg-primary"><i class="fa fa-play"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- About Company END -->
			<!-- Why Choose Us  --> */}
                            <div class="section-full content-inner doctor-stats-bx"
                                style={{ backgroundImage: `url(images/background/bg10.jpg)`, backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom' }}>
                                <div class="container">
                                    <div class="section-head text-center ">
                                        <h3 class="h3 text-uppercase">About <span class="text-primary">Ntinda Dental Clinic.</span></h3>
                                        <p>We use modern technology and experienced professionals to provide trusted services to patients and families while ensuring comfort, safety, and long-lasting oral health through personalized treatment plans and compassionate care.</p>
                                    </div>
                                    <div class="row text-center">
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="counter-style-1 m-b30">
                                                <div class="text-primary">
                                                    <i class="icon flaticon-bar-chart"></i>
                                                    <span class="counter">164</span>
                                                </div>
                                                <span class="counter-text">Completed Surgeries</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="counter-style-1 m-b30">
                                                <div class="text-primary">
                                                    <i class="icon flaticon-social"></i>
                                                    <span class="counter">462</span>
                                                </div>
                                                <span class="counter-text">Happy Clients</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="counter-style-1 m-b30">
                                                <div class="text-primary">
                                                    <i class="icon flaticon-file"></i>
                                                    <span class="counter">106</span>
                                                </div>
                                                <span class="counter-text">Implants Installed</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="counter-style-1 m-b30">
                                                <div class="text-primary">
                                                    <i class="icon flaticon-pencil"></i>
                                                    <span class="counter">109</span>
                                                </div>
                                                <span class="counter-text">Braces Installed</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Why Choose Us END -->
			<!-- Services --> */}
                            <div class="section-full bg-white content-inner" id="our-services">
                                <div class="container">
                                    <div class="section-head text-center ">
                                        <h3 class="h3 text-uppercase">Our <span class="text-primary">Services</span></h3>
                                        <p>Comprehensive dental services using modern technology and experienced professionals.</p>
                                    </div>
                                    <div class="section-content ">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        {/* <a href="#"><img src="assets/images/our-services/service/pic1.jpg"
                                                        alt="" /></a>  */}

                                                        <ReactBeforeSliderComponent
                                                            firstImage={SECOND_IMAGE}
                                                            secondImage={FIRST_IMAGE}
                                                        />

                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Dental Fillings</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">
                                                            Restore damaged or decayed teeth with durable, natural-looking fillings.
                                                            Our treatments protect your tooth structure and prevent further decay.
                                                            Enjoy a healthier long-lasting smile.
                                                            . </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        {/* <a href="#"><img src="assets/images/our-services/service/pic2.jpg"
                                                        alt="" /></a>  */}

                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGE2}
                                                            secondImage={SECOND_IMAGE2}
                                                        />



                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Orthodontics</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">

                                                            Straighten misaligned teeth and improve your bite with modern orthodontic care.
                                                            We offer solutions like braces and aligners tailored to your needs.
                                                            Achieve a confident, well-aligned smile over time.. </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        {/* <a href="#"><img src="assets/images/our-services/service/pic3.jpg"
                                                        alt="" /></a>  */}

                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGE4}
                                                            secondImage={SECOND_IMAGE4}
                                                        />

                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Implants</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">Replace missing teeth with strong, natural-looking dental implants.
                                                            They restore function, appearance, and long-term oral health.
                                                            Enjoy a permanent solution that feels just like your own teeth. </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}> <a href="#"><img src="assets/images/our-services/service/pic4.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Root Canal Treatment</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">Save infected or damaged teeth with gentle root canal therapy that restore the tooth’s strength and function.
                                                            Relieve pain and preserve your natural smile effectively.</p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        {/* <a href="#"><img src="assets/images/our-services/service/pic5.jpg"
                                                        alt="" /></a>  */}

                                                        {/* <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGEW}
                                                            secondImage={SECOND_IMAGEW}
                                                        /> */}

                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGE3}
                                                            secondImage={SECOND_IMAGE3}
                                                        />

                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Teeth Whitening</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">Brighten your smile with safe and effective whitening treatments.
                                                            Remove stains caused by food, drinks, and lifestyle habits.
                                                            Reveal a noticeably whiter and more radiant smile.</p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}> <a href="#"><img src="assets/images/our-services/service/pic6.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Routine Dental Exam</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">Maintain optimal oral health with regular dental check-ups.
                                                            We detect issues early and provide preventive care solutions.
                                                            Keep your teeth and gums healthy with consistent professional care.. </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>




                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>

                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGEsb}
                                                            secondImage={SECOND_IMAGEsa}
                                                        />

                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Teeth Cleaning</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">
                                                            Keep your smile fresh and healthy with professional teeth cleaning services. We gently remove plaque, tartar, and stains while protecting your gums.
                                                            {/* Enjoy a brighter smile, fresher breath, and improved oral health through regular, expert dental care visits. */}
                                                        </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        {/* <a href="#"><img src="assets/images/our-services/service/pic5.jpg"
                                                        alt="" /></a>  */}

                                                        {/* <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGEW}
                                                            secondImage={SECOND_IMAGEW}
                                                        /> */}

                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGECB}
                                                            secondImage={SECOND_IMAGECA}
                                                        />

                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Oral Surgery</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">
                                                            Restore comfort and function with safe and precise oral surgery procedures. We handle tooth extractions, impacted teeth, and other conditions with care.
                                                            {/* Our goal is to relieve pain, promote healing, and ensure a smooth recovery for your long-term oral health. */}
                                                        </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box">
                                                    <div class="dez-media" style={{height: '200px'}}>
                                                        <ReactBeforeSliderComponent
                                                            firstImage={FIRST_IMAGEBB}
                                                            secondImage={SECOND_IMAGEBA}
                                                        />
                                                    </div>
                                                    <div class="dez-info p-a30 border-1">
                                                        <h4 class="dez-title m-t0"><a href="#">Dental Bridges</a></h4>
                                                        <div class="dez-separator bg-primary"></div>
                                                        <p class="m-b15">Replace missing teeth and restore your confident smile with durable dental bridges that improve chewing, speech, and alignment.
                                                            {/* Regain full function and maintain oral balance while enhancing both appearance and everyday comfort  */}
                                                        </p>
                                                        {/* <a href="#" class="site-button-link black">Read More <i
                                                            class="fa fa-long-arrow-right"></i></a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Services END -->
			<!-- Our Project --> */}
                            <div class="section-full bg-img-fix overlay-primary-dark content-inner-1 dez-support"
                                style={{ backgroundImage: `url(images/background/bg5.jpg)` }}>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-12 text-center text-white ">
                                            <h2 class="m-b15 m-t0">We provide 24/7 customer support.</h2>
                                            <h3 class="m-t0 m-b20">Please feel free to contact us at +256 754 229 749 for emergency case.
                                            </h3>
                                            <a href="#" class="site-button white radius-sm">We are here to help</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Our Project END -->
			<!-- Meet Our Team -->
			<!-- Team member --> */}
                            <div class="section-full content-inner bg-gray" id='our-team' style={{ display: 'none' }}>
                                <div class="container">
                                    <div class="section-head text-center ">
                                        <h3 class="h3 text-uppercase">Meet Our <span class="text-primary">Doctors</span></h3>
                                        <p>Our experienced dental team is dedicated to delivering exceptional care with professionalism to ensure every patient receives personalized treatment, comfort, and confident, healthy smiles.</p>
                                    </div>
                                    <div class="section-content text-center ">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box team-bx1">
                                                    <div class="dez-media"> <a href="#"><img src="assets/images/our-team/small/pic1.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-t20">
                                                        <h4 class="dez-title m-b10"><a href="#">Nashid Martines</a></h4>
                                                        <h6 class="dez-title">Cardiac surgery</h6>
                                                        <p class="m-b10">Lorem Ipsum is simply dummy text of the printing and
                                                            typesetting industry lorem Ipsum has..</p>
                                                        <ul class="dez-social-icon border dez-social-icon-lg">
                                                            <li><a href="javascript:void(0);" class="fa fa-facebook"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-twitter"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-linkedin"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-pinterest-p"></a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box team-bx1">
                                                    <div class="dez-media"> <a href="#"><img src="assets/images/our-team/small/pic2.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-t20">
                                                        <h4 class="dez-title m-b10"><a href="#">Nashid Martines</a></h4>
                                                        <h6 class="dez-title">Cardiac surgery</h6>
                                                        <p class="m-b10">Lorem Ipsum is simply dummy text of the printing and
                                                            typesetting industry lorem Ipsum has..</p>
                                                        <ul class="dez-social-icon border dez-social-icon-lg">
                                                            <li><a href="javascript:void(0);" class="fa fa-facebook"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-twitter"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-linkedin"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-pinterest-p"></a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box team-bx1">
                                                    <div class="dez-media"> <a href="#"><img src="assets/images/our-team/small/pic3.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-t20">
                                                        <h4 class="dez-title m-b10"><a href="#">Nashid Martines</a></h4>
                                                        <h6 class="dez-title">Cardiac surgery</h6>
                                                        <p class="m-b10">Lorem Ipsum is simply dummy text of the printing and
                                                            typesetting industry lorem Ipsum has..</p>
                                                        <ul class="dez-social-icon border dez-social-icon-lg">
                                                            <li><a href="javascript:void(0);" class="fa fa-facebook"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-twitter"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-linkedin"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-pinterest-p"></a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                                <div class="dez-box team-bx1">
                                                    <div class="dez-media"> <a href="#"><img src="assets/images/our-team/small/pic4.jpg"
                                                        alt="" /></a> </div>
                                                    <div class="dez-info p-t20">
                                                        <h4 class="dez-title m-b10"><a href="#">Nashid Martines</a></h4>
                                                        <h6 class="dez-title">Cardiac surgery</h6>
                                                        <p class="m-b10">Lorem Ipsum is simply dummy text of the printing and
                                                            typesetting industry lorem Ipsum has..</p>
                                                        <ul class="dez-social-icon border dez-social-icon-lg">
                                                            <li><a href="javascript:void(0);" class="fa fa-facebook"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-twitter"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-linkedin"></a></li>
                                                            <li><a href="javascript:void(0);" class="fa fa-pinterest-p"></a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Team member END -->
			<!-- Testimoniay --> */}
                            {/* <div class="section-full owl-dots-style md-testimonial"
                                style={{backgroundImage:`url(images/background/bg3.jpg)`, backgroundSize:'cover'}}>
                                <div class="container-fluid p-a0">
                                    <div class="section-content col-md-6 overlay-primary-dark content-inner-1"
                                        style={{backgroundImage : `url(images/background/bg3.jpg)`}}>
                                        <div
                                            class="testimonial-six relative z-index2 owl-theme owl-loaded owl-carousel owl-none owl-dots-white-full max-w700 m-auto">
                                            <div class="item">
                                                <div class="testimonial-1 testimonial-bg">
                                                    <div class="testimonial-pic quote-left radius shadow"><img
                                                        src="assets/images/testimonials/pic1.jpg" width="100" height="100" alt="" /></div>
                                                    <div class="testimonial-text">
                                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                            Lorem Ipsum has been the industry's standard dummy text ever since the when
                                                            an printer took a galley of type and scrambled it to make a type specimen
                                                            book. It has survived not only five centuries, but also the leap into
                                                            electronic typesetting, remaining essentially unchanged. It was popularised
                                                            in the 1960s with the release of Letraset sheets conta</p>
                                                    </div>
                                                    <div class="testimonial-detail"> <strong class="testimonial-name">David
                                                        Matin</strong> <span class="testimonial-position">Student</span> </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="testimonial-1 testimonial-bg">
                                                    <div class="testimonial-pic quote-left radius shadow"><img
                                                        src="assets/images/testimonials/pic2.jpg" width="100" height="100" alt="" /></div>
                                                    <div class="testimonial-text">
                                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                            Lorem Ipsum has been the industry's standard dummy text ever since the when
                                                            an printer took a galley of type and scrambled it to make a type specimen
                                                            book. It has survived not only five centuries, but also the leap into
                                                            electronic typesetting, remaining essentially unchanged. It was popularised
                                                            in the 1960s with the release of Letraset sheets conta</p>
                                                    </div>
                                                    <div class="testimonial-detail"> <strong class="testimonial-name">David
                                                        Matin</strong> <span class="testimonial-position">Student</span> </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="testimonial-1 testimonial-bg">
                                                    <div class="testimonial-pic quote-left radius shadow"><img
                                                        src="assets/images/testimonials/pic3.jpg" width="100" height="100" alt="" /></div>
                                                    <div class="testimonial-text">
                                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                            Lorem Ipsum has been the industry's standard dummy text ever since the when
                                                            an printer took a galley of type and scrambled it to make a type specimen
                                                            book. It has survived not only five centuries, but also the leap into
                                                            electronic typesetting, remaining essentially unchanged. It was popularised
                                                            in the 1960s with the release of Letraset sheets conta</p>
                                                    </div>
                                                    <div class="testimonial-detail"> <strong class="testimonial-name">David
                                                        Matin</strong> <span class="testimonial-position">Student</span> </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- Testimoniay END -->
			<!-- Latest Blog --> */}
                            {/* <div class="section-full bg-white content-inner-1">
                                <div class="container">
                                    <div class="section-head text-center ">
                                        <h3 class="h3 text-uppercase">Recent <span class="text-primary">Blog</span></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry has been the
                                            industry's standard dummy text ever since the been when an unknown printer.</p>
                                    </div>
                                    <div class="section-content">
                                        <div
                                            class="blog-carousel owl-carousel owl-theme owl-btn-1 primary owl-btn-center-lr owl-dots-black-full">
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic2.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic3.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic4.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic2.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic3.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="dez-box">
                                                    <div class="dez-media">
                                                        <a href="#"><img src="assets/images/our-services/service/pic4.jpg" alt="" /></a>
                                                    </div>
                                                    <div class="dez-info p-a20 border-1">
                                                        <div class="dez-post-meta ">
                                                            <ul>
                                                                <li class=""> <i class="fa fa-calendar"></i><strong>10 Aug</strong>
                                                                    <span> 2020</span> </li>
                                                                <li class="post-author"><i class="fa fa-user"></i>By <a
                                                                    href="#">Jone</a> </li>
                                                                <li class="post-comment"><i class="fa fa-comments"></i> <a
                                                                    href="#">0</a> </li>
                                                            </ul>
                                                        </div>
                                                        <h4 class="dez-title m-t5 m-b10"><a href="#">Provide qualtiy productivity..</a>
                                                        </h4>
                                                        <p class="m-b15">Lorem ipsum dolor Fusce varius euismod lacus eget feugiat rorem
                                                            ipsum dolor consectetur Fusce varius . </p>
                                                        <a href="#" class="site-button">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- Latest Blog END --> */}
                            <div class="section-full bg-primary overlay-primary-dark bg-img-fix"
                                style={{ backgroundImage: `url(images/background/bg9.jpg)` }}>
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-6 col-sm-6 ov-white1 style1 text-white">
                                            <div class="icon-bx-wraper p-a40 center">
                                                <div class="icon-md m-b20"> <span class="icon-cell"><i class="fa fa-clock-o"></i></span>
                                                </div>
                                                <div class="icon-content">
                                                    <h5 class="dez-tilte text-uppercase">CALL CENTER 24/7</h5>
                                                    <p>We’re here for you anytime,
                                                        offering fast support, guidance and
                                                        care whenever you need assistance. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 ov-white2 style1 text-white">
                                            <div class="icon-bx-wraper p-a40 center">
                                                <div class="icon-md m-b20"> <span class="icon-cell"><i class="fa fa-user"></i></span>
                                                </div>
                                                <div class="icon-content">
                                                    <h5 class="dez-tilte text-uppercase">Professional staff</h5>
                                                    <p>Our expert team delivers,
                                                        exceptional service, precision and
                                                        care you can trust every visit.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 ov-white3 style1 text-white">
                                            <div class="icon-bx-wraper p-a40 center">
                                                <div class="icon-md m-b20"> <span class="icon-cell"><i class="fa fa-pencil"></i></span>
                                                </div>
                                                <div class="icon-content">
                                                    <h5 class="dez-tilte text-uppercase">Modern Equipment</h5>
                                                    <p>Powered by latest technology,
                                                        ensuring accurate diagnosis, comfort and
                                                        high-quality treatment every time.. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-6 ov-white4 style1 text-white">
                                            <div class="icon-bx-wraper p-a40 center">
                                                <div class="icon-md m-b20"> <span class="icon-cell"><i
                                                    class="fa fa-file-text"></i></span> </div>
                                                <div class="icon-content">
                                                    <h5 class="dez-tilte text-uppercase">ONLINE APPOINTMENT</h5>
                                                    <p>Book your visit in seconds,
                                                        with our easy system, fast and
                                                        secure scheduling anytime, anywhere. </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="section-full content-inner bg-white contact-style-1" id='contact-us'>
                                <div class="container">
                                    <div class="row">
                                        {/* <!-- right part start --> */}
                                        <div class="col-lg-4 d-flex m-b30">
                                            <div class="p-a30 border contact-area border-1  align-self-stretch">
                                                <h2 class="m-b10">Quick Contact</h2>
                                                <p>If you have any questions simply use the following contact details.</p>
                                                <ul class="no-margin">
                                                    <li class="icon-bx-wraper left m-b30">
                                                        <div class="icon-bx-xs border-1"> <a href="#" class="icon-cell"><i
                                                            class="fa fa-map-marker"></i></a> </div>
                                                        <div class="icon-content">
                                                            <h6 class="text-uppercase m-tb0 dez-tilte">Address:</h6>
                                                            <p>Ntinda Stretcher Road, Opposite New Ntinda market</p>
                                                        </div>
                                                    </li>
                                                    <li class="icon-bx-wraper left  m-b30">
                                                        <div class="icon-bx-xs border-1"> <a href="#" class="icon-cell"><i
                                                            class="fa fa-envelope"></i></a> </div>
                                                        <div class="icon-content">
                                                            <h6 class="text-uppercase m-tb0 dez-tilte">Email:</h6>
                                                            <p><a href="#"
                                                                class="__cf_email__">info@ntindadentalclinic.com</a>
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li class="icon-bx-wraper left">
                                                        <div class="icon-bx-xs border-1"> <a href="#" class="icon-cell"><i
                                                            class="fa fa-phone"></i></a> </div>
                                                        <div class="icon-content">
                                                            <h6 class="text-uppercase m-tb0 dez-tilte">PHONE</h6>
                                                            <p>+256 754 229 749</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div class="m-t20">
                                                    <ul class="dez-social-icon border dez-social-icon-lg">

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- right part END -->
						<!-- Left part start --> */}
                                        <div class="col-lg-4 m-b30">
                                            <div class="p-a30 bg-gray clearfix">
                                                <h2>Send Message Us</h2>
                                                <div class="dzFormMsg"></div>
                                                <form method="post" class="dzForm"
                                                    action="#">
                                                    <input type="hidden" value="Contact" name="dzToDo" />
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <input name="dzName" type="text" required class="form-control"
                                                                        placeholder="Your Name" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <input name="dzEmail" type="email" class="form-control" required
                                                                        placeholder="Your Email Id" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <textarea name="dzMessage" rows="4" class="form-control" required
                                                                        placeholder="Your Message..."></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <div class="g-recaptcha"
                                                                        data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN"
                                                                        data-callback="verifyRecaptchaCallback"
                                                                        data-expired-callback="expiredRecaptchaCallback"></div>
                                                                    <input class="form-control d-none" style={{ display: 'none' }}
                                                                        data-recaptcha="true" required
                                                                        data-error="Please complete the Captcha" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <button name="submit" type="submit" value="Submit" class="site-button ">
                                                                <span>Submit</span> </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        {/* <!-- Left part END --> */}
                                        <div class="col-lg-4 m-b30 d-flex">


                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7462243821583!2d32.61436257506314!3d0.34444286398219487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbb001196709b%3A0x438a0f31ceff10df!2sThe%20Ntinda%20Medical%20and%20Rehabilitation%20Centre!5e0!3m2!1sen!2sug!4v1775296473684!5m2!1sen!2sug" class="align-self-stretch m-b30" style={{ border: '0', width: '100%', minHeight: '100%' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                                        </div>

                                    </div>
                                </div>
                            </div>


                            {/* <!-- Content END--> */}
                        </div>
                        {/* <!-- Footer --> */}
                        <footer class="site-footer map-footer">
                            <div class="footer-top">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6 col-sm-6 footer-col-4">
                                            <div class="widget widget_about">
                                                <h4 class="m-b15 text-uppercase">About Us</h4>
                                                <div class="dez-separator bg-primary"></div>
                                                <p><strong>Ntinda Dental Clinic.</strong>
                                                    At Ntinda Dental Clinic, we combine modern technology with compassionate expertise to deliver safe, effective, and comfortable treatments. From routine check-ups to advanced procedures, your oral health is our priority. Our dedicated team is committed to helping you achieve a healthy, confident smile.
                                                </p>
                                                <ul class="dez-social-icon border">

                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-md-6 col-sm-6 footer-col-4">
                                            <div class="widget widget_services">
                                                <h4 class="m-b15 text-uppercase">Our services</h4>
                                                <div class="dez-separator bg-primary"></div>
                                                <ul>
                                                    <li><a href="#">Dental Fillings & Implants</a></li>
                                                    <li><a href="#">Orthodontics</a></li>
                                                    <li><a href="#">Root Canal Treatment</a></li>
                                                    <li><a href="#">Teeth Whitening</a></li>
                                                    <li><a href="#">Routine Dental Exam</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-6 footer-col-4">
                                            <div class="widget widget_getintuch">
                                                <h4 class="m-b15 text-uppercase">Contact us</h4>
                                                <div class="dez-separator bg-primary"></div>
                                                <ul>
                                                    <li><i class="fa fa-map-marker"></i><strong>address</strong>  Ntinda Stretcher Road, Opposite New Ntinda market </li>
                                                    <li><i class="fa fa-phone"></i><strong>phone</strong>+256 754 229 749 (24/7 Support Line)
                                                    </li>
                                                    <li><i class="fa fa-envelope"></i><strong>email</strong><a
                                                        href="#"
                                                        class="__cf_email__">info@ntindadentalclinic.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- footer bottom part --> */}
                            <div class="footer-bottom ">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-12 text-center"> <span>© Copyright <span class="current-year">2025</span> &nbsp;
                                            Ntinda Dental Clinic. All Rights Reserved.</span> </div>
                                    </div>
                                </div>
                            </div>
                        </footer>

                        <Fab
                            mainButtonStyles={{ backgroundColor: "#D24183" }}
                            icon={<FaHeadset style={{ width: '25px', height: '25px' }} />}
                            position="bottom-left"
                            style={{ bottom: "70px", right: "0px" }} // custom offset
                        >

                            <Action style={{ backgroundColor: "#38a330" }} text="Chat" onClick={() => window.location.href = "tel:+256754229749"}>
                                <i class="fa fa-whatsapp f"></i>
                            </Action>

                            <Action style={{ backgroundColor: "#3396d1" }} text="Call" onClick={() => window.location.href = "tel:+256754229749"}>
                                <i class="fa fa-phone"></i>
                            </Action>

                        </Fab>

                        {/* <!-- Footer END-->
		<!-- scroll top button --> */}
                        <button class="scroltop fa fa-chevron-up"></button>
                    </div>

                </body>


            </>
        )
    }
}
export default Home